import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "../assets/images/churchLogo.png";
import styles from "../styles/Footer.module.css";

const NAV = [
  { label: "About Us",    to: "/about-us"      },
  { label: "Sermons",     to: "/sermons"    },
  { label: "Events",      to: "/events"     },
  { label: "Ministries",  to: "/ministry"   },
  { label: "Fellowship",  to: "/fellowship" },
  { label: "Contact",     to: "/contact-us"    },
];

const MINISTRIES = [
  "Kids Ministry",
  "Youth Ministry",
  "Women Ministry",
  "Men Ministry",
  "Prayer Ministry",
  "Worship Ministry",
];

const SOCIALS = [
  { icon: <FaFacebookF />, href: "https://www.facebook.com/profile.php?id=61558254995939",                         label: "Facebook"  },
  { icon: <FaInstagram />, href: "https://www.instagram.com/calvaryministries_official2/",                         label: "Instagram" },
  { icon: <FaXTwitter  />, href: "https://x.com/CalvaryWFM",                                                       label: "X / Twitter" },
  { icon: <FaYoutube   />, href: "https://www.youtube.com/results?search_query=calvary+wide+fellowship+ministries", label: "YouTube"  },
  { icon: <FaTiktok    />, href: "https://www.tiktok.com/@calvary_wfm?lang=en",                                    label: "TikTok"   },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      {/* Gold top accent */}
      <div className={styles.goldBar} />

      <div className={styles.main}>

        {/* Brand column */}
        <div className={styles.brandCol}>
          <div className={styles.logoRow}>
            <img src={logo} alt="CWFM Logo" className={styles.logo} />
            <span className={styles.brandName}>CWFM</span>
          </div>
          <p className={styles.verse}>
            "For the <strong>Lord</strong> has chosen <strong>Calvary</strong>, He has
            desired it for His dwelling place. This is my resting place for ever and ever;
            here I will sit enthroned, for I have desired it."
          </p>
          <div className={styles.contactList}>
            <div className={styles.contactItem}>
              <Mail size={14} className={styles.contactIcon} />
              <a href="mailto:calvarywfm2017@gmail.com" className={styles.contactLink}>
                calvarywfm2017@gmail.com
              </a>
            </div>
            <div className={styles.contactItem}>
              <Phone size={14} className={styles.contactIcon} />
              <a href="tel:+250783517590" className={styles.contactLink}>
                +250 783 517 590
              </a>
            </div>
            <div className={styles.contactItem}>
              <MapPin size={14} className={styles.contactIcon} />
              <span className={styles.contactLink}>Kigali, Rwanda</span>
            </div>
          </div>
        </div>

        {/* Quick links */}
        <div className={styles.linksCol}>
          <h4 className={styles.colHeader}>Quick Links</h4>
          <ul className={styles.linkList}>
            {NAV.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} className={styles.footerLink}>{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Ministries */}
        <div className={styles.linksCol}>
          <h4 className={styles.colHeader}>Ministries</h4>
          <ul className={styles.linkList}>
            {MINISTRIES.map((m) => (
              <li key={m}>
                <Link to="/ministry" className={styles.footerLink}>{m}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter */}
        <div className={styles.newsletterCol}>
          <h4 className={styles.colHeader}>Stay Connected</h4>
          <p className={styles.newsletterDesc}>
            Get updates on services, events, and devotionals delivered to your inbox.
          </p>
          <form className={styles.newsletterForm} onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Your email address"
              className={styles.newsletterInput}
              required
            />
            <button type="submit" className={styles.subscribeBtn}>Subscribe</button>
          </form>
          <div className={styles.socialsRow}>
            {SOCIALS.map(({ icon, href, label }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                className={styles.socialIcon} aria-label={label}>
                {icon}
              </a>
            ))}
          </div>
        </div>

      </div>

      {/* Bottom bar */}
      <div className={styles.bottomBar}>
        <span className={styles.copyright}>
          &copy; {year} <strong>Calvary Wide Fellowship Ministries</strong>. All rights reserved.
        </span>
        <span className={styles.bottomRight}>
          Built with faith &amp; purpose.
        </span>
      </div>
    </footer>
  );
}
